import { CustomerJourneyNote } from '@/modules/Customer/types'
import * as yup from 'yup'

export const AddCustomerJourneyNoteSchema = yup.object().shape({
    customer_journey_note: yup.string().optional(),
    customer_journey_note_step: yup.string().required(),
    customer_journey_note_step_status: yup.string().required(),
    customer_journey_notes_time: yup
        .mixed<
            Exclude<CustomerJourneyNote['customer_journey_notes_time'], null>
        >()
        .nullable()
        .optional(),
})
